/**
 * Created by adam.clarke on 13/10/2016.
 */

admin.registerLoad(function (prefix) {

    $(prefix + '.js-form-validate').validate(
        {
            ignore: [],
            invalidHandler: function(event, validator) {
                // 'this' refers to the form

                var errors = validator.invalid;
                for (first in errors) break;

                first = first.replace("[", "\\[");
                first = first.replace("]", "\\]");
                $input = $('[name="' + first + '"]');
                var $closest = $input.closest('.tab-pane');
                var id = $closest.attr('id');
                $('.tabs-container a[data-target="#' + id + '"]').tab('show');
            }
        }
    );

    $(prefix +  ".js-validate-number").each(function () {
        var rules = {
            digits: true,
            messages: {
                digits: "Please enter a whole number"
            }
        };

        if ($(this).data('minimum'))
        {
            // add minimum value rule
        }

        if ($(this).data('maximum'))
        {
            // add maximum value rule
        }

        $(this).rules('add', rules);
    });

    $(prefix +  ".js-validate-float").each(function () {
        var rules = {
            number: true,
            number: {
                digits: "Please enter a number"
            }
        };

        if ($(this).data('minimum'))
        {
            // add minimum value rule
        }

        if ($(this).data('maximum'))
        {
            // add maximum value rule
        }

        $(this).rules('add', rules);
    });
});
